@if (formLoading) {
  <div class="progress-spinner">
    <p-blockUI [blocked]="formLoading"></p-blockUI>
    <p-progressSpinner></p-progressSpinner>
  </div>
}
